import moment from "moment";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";

function Video({ video, onImageClick }) {
  const { assets, videoId, title, createdAt } = video;
  const [view, setView] = useState("");
  const router = useRouter();
  let newDate = new Date(createdAt);
  var day = moment(new Date()).diff(moment(new Date()), "days"); // 0

  useEffect(() => {
    setView(Math.floor(Math.random() * 1000));
  }, []);

  return (
    <>
      <div className='filterDiv tips' key={"_" + video.id}>
        <div className='pb-4 pt-2'>
          <div className='item'>
            <div className='content'>
              <img
                style={{ cursor: "pointer" }}
                className='w-100 h-auto'
                loading='lazy'
                src={
                  video.snippet?.thumbnails?.high?.url ||
                  video.snippet?.thumbnails?.default?.url
                }
                alt=''
                width='416'
                height='214'
                onClick={onImageClick}
              />
              <h3
                className='no-padding h5 fw-bold my-1'
                style={{ cursor: "pointer" }}
              >
                {video.snippet?.title}
              </h3>
              <small className='no-padding text-dark'>
                {video.snippet?.channelTitle} |{" "}
                {moment(new Date()).diff(
                  moment(video.snippet?.publishedAt),
                  "days"
                )}{" "}
                days{" "}
              </small>
              {/* <div className="tag">
                <span className="type">Tips</span>
                <span className="type">Tutorials</span>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </>
  );
}

export default Video;
